import { Button, Tooltip } from 'antd';
import { useObjectPickerStore } from '@stores/useObjectPickerStore';
import { useMapToolBusy } from '@hooks/useMapToolBusy';

const ObjectPicker = () => {
	const openObjectPicker = useObjectPickerStore(s => s.open);
	// A detection run started from here would compete with whatever already owns
	// the map — a boundary edit (which re-runs detection itself on confirm), or an
	// AOI draw, over which this wizard would reopen. It stays closed until that
	// one is finished or canceled.
	const { busy: mapBusy, reason: blockedReason } = useMapToolBusy();

	const tooltipTitle = blockedReason || 'Run AI detection';

	return (
		<Tooltip title={tooltipTitle}>
			{/* antd removes pointer events from disabled buttons, so the wrapper
			    keeps the tooltip hoverable while the button is disabled. */}
			<span data-tour="ai-detection">
				<Button
					type="primary"
					onClick={openObjectPicker}
					disabled={mapBusy}
					aria-label={tooltipTitle}>
					AI Detection
				</Button>
			</span>
		</Tooltip>
	);
};

export default ObjectPicker;
